export const BASE_TIMER_DATA = {
  initialization: 0,
  render: 0,
  renderData: 0,
}

export const MAX_MEASURE_TIME = 60000
export const MIN_MEASURE_TIME = 0
export const STORAGE_KEY = 'logger_measure_controller'
